import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import isEmpty from 'lodash.isempty'
import PropTypes from 'prop-types'
import { PHOTO_VALID } from 'constants/index'
import messages from './translate'

class ChangeFileDialog extends Component {
  state = {
    image: {
      file: null,
      content: null,
    },
    notification: false,
  }

  onChange = e => {
    const file = e.target.files[0]
    const fr = new FileReader()
    const { typesLimitation } = this.props

    if (
      !isEmpty(typesLimitation) &&
      file &&
      !typesLimitation.includes(file.type)
    ) {
      this.setState({ notification: true })

      return
    }

    fr.onload = () =>
      this.setState({
        image: {
          file,
          content: fr.result,
        },
        notification: false,
      })

    if (file) {
      fr.readAsDataURL(file)
    }
  }

  onSave = () => {
    const {
      fileUpload,
      entityId,
      intl: { formatMessage },
    } = this.props
    const fileData = this.state.image.file
    let data = {}

    if (!data) {
      // TODO вызвать нотификацию
      console.log('ERROOR FILE EMPTY')

      return
    }

    const { size, type } = fileData
    const { fileSize, fileType } = PHOTO_VALID
    const isTypeValid = fileType.some(x => x === type)

    if (size <= fileSize && isTypeValid) {
      data = {
        fileData,
        entityId,
        message: formatMessage(messages.updateLogo),
      }
      fileUpload(data)
      this.onClose()
    } else {
      this.setState({
        error: 'Error',
      })
      // TODO вызвать нотификацию ошибки
      console.log('ERROOR', size <= fileSize, isTypeValid)
    }
  }

  onClose = () => {
    this.setState({
      image: {
        file: null,
        content: null,
      },
      notification: false,
    })
    this.props.onCloseLogoChange()
  }

  getOverlayContent = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { notification } = this.state

    return notification ? (
      <div className="form-dialog-notification-box">
        <Icon>block</Icon>
        <p className="form-dialog-notification-text">
          {formatMessage(messages.imageTypeSVG)}
        </p>
      </div>
    ) : (
      <Icon>photo</Icon>
    )
  }

  render() {
    const {
      title,
      isOpenLogoChange,
      intl: { formatMessage },
    } = this.props
    const { image } = this.state
    const isImage = !image.file

    return (
      <Dialog
        open={isOpenLogoChange}
        onClose={this.onClose}
        className="change-logo-dialog"
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <div className="logo">
            <label htmlFor="contained-button-file">
              {image.content ? (
                <img src={image.content} alt="Logo" />
              ) : (
                <div className="overlay">{this.getOverlayContent()}</div>
              )}
              <div className="overlay" />
            </label>
            <input
              id="contained-button-file"
              type="file"
              accept="image/*"
              onChange={this.onChange}
              style={{ display: 'none' }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            component="span"
            color="default"
            onClick={this.onClose}>
            {formatMessage(messages.cancel)}
          </Button>
          <Button
            variant="contained"
            component="span"
            color="primary"
            disabled={isImage}
            onClick={this.onSave}>
            {formatMessage(messages.save)}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

ChangeFileDialog.propTypes = {
  typesLimitation: PropTypes.array,
}

ChangeFileDialog.defaultProps = {
  typesLimitation: [],
}

export default injectIntl(ChangeFileDialog)
